import React, { useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Brain, Sparkles, Loader2 } from "lucide-react";

export default function IAInsights() {
  const [briefing, setBriefing] = useState(null);
  const [perdas, setPerdas] = useState(null);
  const [busy, setBusy] = useState(null);

  const gerar = async (kind) => {
    setBusy(kind);
    try {
      if (kind === "briefing") {
        const { data } = await api.get("/ai/briefing-diretor");
        setBriefing(data.briefing);
      } else if (kind === "perdas") {
        const { data } = await api.get("/ai/propostas-perdidas");
        setPerdas(data.analise);
      }
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-md flex items-center justify-center text-white" style={{ background: "#1B3A6B" }}>
          <Brain size={22} />
        </div>
        <div>
          <h1 className="text-3xl font-display font-bold" style={{ color: "#1B3A6B" }}>Insights IA</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Análises geradas por Claude · <span className="font-mono">claude-sonnet-4-5</span>
          </p>
        </div>
      </div>

      <Tabs defaultValue="briefing">
        <TabsList>
          <TabsTrigger value="briefing" data-testid="tab-briefing">Briefing diário</TabsTrigger>
          <TabsTrigger value="perdas" data-testid="tab-perdas">Propostas perdidas</TabsTrigger>
        </TabsList>

        <TabsContent value="briefing" className="mt-4">
          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-bold text-lg">Briefing executivo do diretor</h3>
              <Button data-testid="gerar-briefing" onClick={() => gerar("briefing")} disabled={busy === "briefing"} className="text-white" style={{ background: "#F97316" }}>
                {busy === "briefing" ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Sparkles size={14} className="mr-2" />}
                Gerar agora
              </Button>
            </div>
            {briefing ? (
              <pre className="whitespace-pre-wrap text-sm font-sans leading-relaxed">{briefing}</pre>
            ) : (
              <p className="text-muted-foreground text-sm">Clique em "Gerar agora" para um resumo executivo das operações do dia.</p>
            )}
          </Card>
        </TabsContent>

        <TabsContent value="perdas" className="mt-4">
          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-bold text-lg">Análise de propostas perdidas</h3>
              <Button data-testid="gerar-perdas" onClick={() => gerar("perdas")} disabled={busy === "perdas"} className="text-white" style={{ background: "#F97316" }}>
                {busy === "perdas" ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Sparkles size={14} className="mr-2" />}
                Analisar últimos 90 dias
              </Button>
            </div>
            {perdas ? (
              <pre className="whitespace-pre-wrap text-sm font-sans leading-relaxed">{perdas}</pre>
            ) : (
              <p className="text-muted-foreground text-sm">Identifique padrões e top 3 motivos de perda nas propostas dos últimos 90 dias.</p>
            )}
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
